import { render, staticRenderFns } from "./releases.vue?vue&type=template&id=4cc5b579&scoped=true"
import script from "./releases.vue?vue&type=script&lang=js"
export * from "./releases.vue?vue&type=script&lang=js"
import style0 from "./releases.vue?vue&type=style&index=0&id=4cc5b579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5b579",
  null
  
)

export default component.exports